<template>
<span>
  <span v-if="!size">
    <b-button size="sm" @click="del()"
      style="margin-bottom:0"
      v-if="!clicks"
      variant="outline-danger">
      Delete
    </b-button>
    <b-button size="sm" @click="delConfirm()"
      style="margin-bottom:0"
      title="Confirm Request to Delete"
      v-if="clicks == 1"
      class="delconf_left"
      variant="danger">
      Confirm?
    </b-button>
    <b-button size="sm" @click="delCancel()"
      style="margin-bottom:0"
      title="Cancel Request to Delete"
      class="typcn typcn-times delconf_right"
      v-if="clicks == 1"
    >
    </b-button>
    <b-button size="sm"
      v-if="clicks == 2"
      variant="outline-secondary">
      Deleting...
    </b-button>
  </span>
  <span v-if="size == 'sm'">
    <b-button size="sm" class="cdel_btn_mat"
      style="color: #c82333;"
      @click="del()"
      v-if="!clicks"
      variant="danger">delete_outline</b-button>
    <b-button size="sm" class="cdel_btn_mat"
      style="color: #c82333;margin-right:-3px;padding-right:0;"
      v-if="clicks == 1"
      @click="delConfirm()"
      variant="danger">delete_forever</b-button>
    <span v-if="clicks == 1"
      style="color: black;font-size:0.9rem;font-weight:900;"
      >?</span>
  </span>
</span>
</template>

<script>

export default {
  name: "ConfirmDel",
  props: ['variant','clear','size','timeout'],
  components: {
  },
  watch: {
    clear: {
      handler: function (to, from) {
        this.clicks = 0;
      },
    },
  },
  data() {
    return  {
       clicks: 0,
    };
  },
  computed: {
  },
  methods: {
    del: function() {
       let vue = this;
       vue.clicks = 1;
       vue.tid = setTimeout(function() {
         vue.clicks = 0;
       }, ((0|vue.timeout) || 4000));
    },
    delConfirm: function() {
       let vue = this;
       vue.clicks = 2;
       clearTimeout(vue.tid);
       vue.$emit('confirmed-delete');
    },
    delCancel: function() {
       let vue = this;
       vue.clicks = 0;
       clearTimeout(vue.tid);
    },
  },
}
</script>

<style lang="scss" scoped>
.delconf_left {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  margin-right: 0;
}

.delconf_right {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  margin-left: 0;
  cursor:pointer;
  background-color:#cccccc;
  color: black;
  font-size: 1.2rem;
  line-height: 1.1;
  padding-left: 0.2rem;
  padding-right: 0.2rem;
}

.delconf_count_down {
  /*animation: 4s linear 0s infinite alternate an_count_down;*/
}
@keyframes an_count_down {
  from { background: linear-gradient(90deg, red, transparent 100%) }
  to { background: linear-gradient(90deg, red, transparent 10%) }
}

.cdel_btn_mat {
  font-family: 'Material Icons';
  font-size: 1.5rem;
  line-height: 1.5rem;
  height: 1.5rem;
  padding:0 0.3rem;
  margin-bottom:0;
  background-color: transparent;
  border:none;
}

</style>